import React, { Fragment, FunctionComponent, useState } from "react";
import styles from "./MegaDropdown.module.scss";
import MegaDropdownProps from "./MegaDropdownProps.interface";
import LinkSlideLeft from "./Animations/LinkSlideLeft/LinkSlideLeft";
import { AnimatePresence, motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import Anchor from "components/Anchor/Anchor";
import megaDropdownHandler from "layout/helpers/megaDropdownHandler";
import MenuLink, { SubMenuLink } from "blocks/models/menu-link.interface";
import { CLOSE_ALL_OVERLAYS } from "layout/redux/overlay.actions";
import FocusTrap from "focus-trap-react";
import IconViewer from "components/IconViewer/IconViewer";

const MegaDropdown: FunctionComponent<MegaDropdownProps> = (props) => {
    const dispatch = useDispatch();
    const overlay = useSelector(state => state.overlay);
    const menuOpen = useSelector(state => state.overlay.menuOpen);
    const [clickedLink, setClickedLink] = useState<null | number>(null);

    const subMenuTriggerHandler = (event: any, firstItem: any, index: number) => {
        event?.preventDefault();

        if (typeof(index) !== "undefined") {
            setClickedLink(index);
        }

        megaDropdownHandler(event, props.menu, firstItem.content.subMenu, dispatch, overlay);
    };

    const handleClick = () => {
        dispatch({
            type: CLOSE_ALL_OVERLAYS,
        });
    };

    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const listItem = {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: {
            ease: "easeInOut"
        } }
    };

    return (
        <Fragment>
            {/* Lock the scrollbar for the rest of the page on mobile, while drawer is open */}
            {/* TODO: Remember the scroll position and restore it when toggling locked state */}
            <Helmet bodyAttributes={{ class: "is-locked" }} />

            <FocusTrap active={menuOpen} focusTrapOptions={{ allowOutsideClick: true }}>
                <nav className={styles.wrapper}>
                    <div className={styles.inner}>
                        <div className={styles.content}>
                            {/* 1. Level */}
                            <nav className={styles.navigation}>
                                {props.menu ? props.menu.map((firstItem: MenuLink, index: number) => {
                                    return (
                                        <Fragment key={index}>
                                            {firstItem.content.subMenu && firstItem.content.subMenu.length > 0 ? (
                                                <div tabIndex={0} className={styles.link_wrapper} onKeyDown={event => { if (event.key === "Enter") subMenuTriggerHandler(event, firstItem, index); }} onClick={event => subMenuTriggerHandler(event, firstItem, index)}>
                                                    <div className={styles.first_level_link_with_submenu}>
                                                        <LinkSlideLeft clickedLink={clickedLink === index}>
                                                            {firstItem.content.label}
                                                        </LinkSlideLeft>
                                                    </div>
                                                </div>
                                            ) : null}

                                            {!firstItem.content.subMenu || firstItem.content.subMenu.length === 0 ? (
                                                <div className={styles.link_wrapper} onClick={handleClick}>
                                                    <Anchor className={styles.first_level_link_single} to={firstItem.content.link}>
                                                        {firstItem.content.label}
                                                    </Anchor>
                                                </div>
                                            ) : null}
                                        </Fragment>
                                    );
                                }) : null}
                            </nav>

                            {/* 2. Level */}
                            <nav className={styles.sub_navigation}>
                                {props.menu && clickedLink ? (
                                    <Anchor className={styles.sub_heading_link} to={props.menu[clickedLink].content.link}>
                                        {props.menu[clickedLink].content.label}
                                    </Anchor>
                                ) : null}

                                <AnimatePresence>
                                    {props.subMenu ?
                                        <motion.div variants={container} initial="hidden" animate="show" >
                                            {props.subMenu && props.subMenu.length > 0 ? props.subMenu.map((secondItem: SubMenuLink, index: number) => {
                                                return (
                                                    <motion.div variants={listItem} className={styles.second_level_link_wrapper} key={secondItem.contentUdi} onClick={handleClick}>
                                                        <Anchor className={styles.second_level_link} to={secondItem.content.link}>
                                                            {secondItem.content.label}
                                                        </Anchor>
                                                    </motion.div>
                                                );
                                            }) : null}
                                        </motion.div>
                                        : null}
                                </AnimatePresence>
                            </nav>
                        </div>
                    </div>
                    {/* Accessibility Close Menu */}
                    <button className={styles.accessibility_close_menu} onClick={handleClick} aria-label="Close Main Menu"></button>
                </nav>
            </FocusTrap>
        </Fragment>
    );
};

export default MegaDropdown;